module.exports = __webpack_public_path__ + "static/media/head-main.2ee81207.png";